export const FindMoreLoader = () => <div className="find-more-loader" />;
